import Flex from '@Components/Bases/Flex';
import { IntroductionButton, RemarkButton } from '@Components/IconButton';
import Introduction from '@Components/Introduction';
import Remark from '@Components/Remark';
import { useDisclosure } from '@hooks/useDisclosure';
import { Box, Typography } from '@mui/material';
import { useWatch } from 'react-hook-form';
import { useNatureOfBusinessForm } from '../NatureOfBusinessFormProvider';
import { MarketingIndustryFormValues } from '../NatureOfBusinessFormProvider/types';
import MarketPoliciesForm from './MarketPoliciesForm';
import MarketPoliciesFormCompletionCheckbox from './MarketPoliciesFormCompletionCheckbox';

const MarketPolicies = () => {
  const { getValues } = useNatureOfBusinessForm();
  const { introduction, remark } =
    getValues(`marketingIndustry`) ?? ({} as MarketingIndustryFormValues);

  const [
    openIntroduction,
    { open: openIntroductionDialog, close: closeIntroduction },
  ] = useDisclosure(!!introduction);
  const [openRemark, { open: openRemarkDialog, close: closeRemark }] =
    useDisclosure(!!remark);

  const { completedSection } =
    useWatch({ name: 'marketingIndustry' }) ??
    ({} as MarketingIndustryFormValues);
  const { isCompletedTh, isCompletedEn } = completedSection ?? {};

  const disableActions = !!isCompletedTh && !!isCompletedEn;

  return (
    <Box bgcolor={'common.white'}>
      <Box p={2}>
        <Flex justifyContent={'space-between'} alignItems={'center'}>
          <Flex gap={1} alignItems={'center'}>
            <Typography fontWeight={800}>การตลาดและการแข่งขัน</Typography>
            <Flex gap={0.5} alignItems={'center'}>
              <IntroductionButton
                disabled={disableActions}
                onClick={() => openIntroductionDialog()}
              />
              <RemarkButton
                disabled={disableActions}
                onClick={() => openRemarkDialog()}
              />
            </Flex>
          </Flex>
        </Flex>
        {openIntroduction && (
          <Box mt={2}>
            <Introduction
              onDelete={closeIntroduction}
              topic="การตลาดและการแข่งขัน"
              setOpen={openIntroductionDialog}
              fieldPath="marketingIndustry.introduction"
              isCompletedEn={isCompletedEn}
              isCompletedTh={isCompletedTh}
            />
          </Box>
        )}
        {openRemark && (
          <Box mt={2}>
            <Remark
              onDelete={closeRemark}
              topic="การตลาดและการแข่งขัน"
              setOpen={openRemarkDialog}
              fieldPath="marketingIndustry.remark"
              isCompletedEn={isCompletedEn}
              isCompletedTh={isCompletedTh}
            />
          </Box>
        )}
        <MarketPoliciesForm />
      </Box>
      <MarketPoliciesFormCompletionCheckbox />
    </Box>
  );
};

export default MarketPolicies;
